<template>
  <section class="section pt-2">
    <div class="title is-5">{{ $t("warehouse organizator") }}</div>
    <div class="columns">
      <div class="column is-one-fifth">
        <div class="title is-6">{{ $t("warehouses") }}</div>
        <warehouse-list
          ref="warehouse_list"
          @warehouse-selected="warehouse_selected"
        />
      </div>
      <div class="column">
        <div class="title is-6">{{ $t("warehouse products") }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import { get, error_message } from "@/utils";
import WarehouseList from "./warehouse_list/Index.vue";

export default {
  name: "InventoryWarehouseOrganize",
  components: {
    WarehouseList,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    warehouse_selected(warehouse) {
      let v = this;
      let uuid = undefined;
      if (warehouse == "unorganized") uuid = "unorganized";
      else uuid = warehouse.uuid;

      get("/inventory/warehouse/products", { uuid: uuid })
        .then((products) => {
          console.log(products);
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
